import { RoutePath } from 'enums/routePath';

const ROOT = `/analyse-agreement-revenue`;

const TRACK_REVENUE_OVER_TIME = `${ROOT}/total-revenue-trend`; // /agreement-revenue
const TRACK_REVENUE_CHANGE_OVER_TIME = `${ROOT}/revenue-changes`; // agreement-revenue-change
const TRACK_REVENUE_BY_PRODUCT = `${ROOT}/product-growth`; // product-subcategory-revenue
const TRACK_REVENUE_BY_CUSTOMER = `${ROOT}/customer-growth`; // /company-agreement-revenue

const paths = {
  [RoutePath.TRACK_REVENUE]: ROOT,
  [RoutePath.TRACK_REVENUE_OVER_TIME]: TRACK_REVENUE_OVER_TIME,
  [RoutePath.TRACK_REVENUE_CHANGE_OVER_TIME]: TRACK_REVENUE_CHANGE_OVER_TIME,
  [RoutePath.TRACK_REVENUE_BY_PRODUCT]: TRACK_REVENUE_BY_PRODUCT,
  [RoutePath.TRACK_REVENUE_BY_CUSTOMER]: TRACK_REVENUE_BY_CUSTOMER,
};

export const pathArray = Object.values(paths);

export default paths;
